module.exports = __webpack_public_path__ + "img/report-sample-10@3x.54c1bed6.png";